<template>
  <div class="login-container">
    <div class="login-tab-box">
      <header>
        <div class="title">欢迎使用商家后台</div>
      </header>
      <el-tabs v-model="activeName" class="login-tab">
        <el-tab-pane name="normal">
          <span slot="label" class="login-tab-title">密码登录</span>
          <div class="login-tab-content">
            <el-form
              autocomplete="on"
              :model="loginForm"
              :rules="loginRules"
              ref="loginForm"
              label-position="left"
              label-width="0px"
            >
              <el-form-item prop="account">
                <el-input
                  name="loginName"
                  type="text"
                  ref="loginName"
                  v-model.trim="loginForm.account"
                  autocomplete="on"
                  placeholder="手机号"
                ></el-input>
              </el-form-item>

              <el-form-item prop="password">
                <el-input
                  name="password"
                  type="password"
                  ref="password"
                  @keyup.enter.native="handleLogin"
                  v-model.trim="loginForm.password"
                  autocomplete="on"
                  placeholder="密码"
                ></el-input>
              </el-form-item>

              <div>
                <el-button
                  type="primary"
                  style="width:100%;"
                  :loading="loading"
                  @click.prevent.enter.native="handleLogin"
                  >登录</el-button
                >
              </div>
              <!--<router-link to="/sendpwd" class="forget-pwd">-->
              <!--忘记密码?-->
              <!--</router-link>-->
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="dynamic">
          <span slot="label" class="login-tab-title">短信登录</span>
          <div class="login-tab-content">
            <el-form>
              <el-form-item>
                <el-input v-model.trim="dynamicForm.account" placeholder="手机号" :maxlength="11">
                  <el-button
                    class="get-code-btn"
                    slot="append"
                    @click="handleGetCode()"
                    :disabled="isCountDown"
                    >{{ isCountDown ? countDown + 's' : '获取验证码' }}</el-button
                  >
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model.trim="dynamicForm.code" placeholder="验证码"></el-input>
              </el-form-item>
              <div>
                <el-button
                  type="primary"
                  @click.enter.native="handleDynamicLogin()"
                  class="login-submit"
                  :loading="loading"
                  >登录</el-button
                >
              </div>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { validateMobile } from '@/common/utils/validate'
import { ZM_ROOT } from '@/common/constants'

export default {
  name: 'Login',
  data() {
    return {
      activeName: 'normal',
      // activeName: "dynamic",
      dynamicForm: {
        account: '',
        code: ''
      },
      loginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [{ required: true, trigger: 'blur', message: '帐号不能为空' }],
        password: [{ required: true, trigger: 'blur', message: '密码不能为空' }]
      },
      loading: false,
      timer: null,
      countDown: 0
    }
  },
  beforeCreate() {
    const href = window.location.href
    const isDev = !href.match(/\.zhaogang(.*)\.com/)
    if (!isDev) {
      const query = this.$route.query
      const jumpLink = href.split('/#')[0]
      let redirect = '/'
      if (query.redirect) {
        redirect = query.redirect
      }
      const url = encodeURIComponent(`${jumpLink}/#${redirect}`)
      window.location.href = `${ZM_ROOT}/login?loginType=0&jump=${url}`
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  computed: {
    isCountDown() {
      return this.countDown > 0
    }
  },
  mounted() {
    if (this.loginForm.username === '') {
      this.$refs.loginName.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
  },
  methods: {
    async handleGetCode() {
      try {
        if (!validateMobile(this.dynamicForm.account)) {
          this.$message.error('请填写正确的手机号码！')
          return
        }
        this.startCountdown()
        const result = await this.$post('user.requestSmsPassword', {
          mobile: this.dynamicForm.account,
          smsType: 'LOGIN' // "REGISTER"
        })
        if (result.success) {
          if (result.data[0].result) {
            this.$message.success('发送成功')
          } else {
            this.$message.error('获取短信失败')
          }
        }
      } catch (e) {
        console.log('err:', e)
      }
    },
    async handleDynamicLogin() {
      try {
        if (!validateMobile(this.dynamicForm.account)) {
          this.$message.error('请填写正确的手机号码')
          return
        }
        this.loading = true
        let res = await this.$store.dispatch('user/loginWithCode', this.dynamicForm)
        this.loading = false
        this.$router.push({
          path: this.redirect || '/',
          query: this.otherQuery
        })
      } catch (e) {
        this.loading = false
        console.log('err:', e)
        // this.$message.error(e.msg)
      }
    },
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          if (!validateMobile(this.loginForm.account)) {
            this.$message.error('请填写正确的手机号码！')
            return
          }
          this.loading = true
          this.$store
            .dispatch('user/loginWithPass', this.loginForm)
            .then(res => {
              this.loading = false
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery
              })
            })
            .catch(err => {
              this.loading = false
              console.log('err:', err)
              // this.$message.error(err.msg || '')
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    startCountdown() {
      this.countDown = 60
      this.timer = setInterval(() => {
        this.countDown-- || this.clearTimer()
      }, 1000)
    },
    clearTimer() {
      this.timer && clearInterval(this.timer)
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    }
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style lang="scss">
.login-container {
  height: 100%;
  background: #eceff1;
  /deep/.el-input-group__append {
    .get-code-btn {
      color: #ffffff;
      background-color: #f0242e;
      border-color: #f0242e;
    }
    .get-code-btn[disabled] {
      color: #909399;
      background-color: #f5f7fa;
      border-color: #f5f7fa;
    }
  }
}
.login-tab-wrap {
  position: relative;
}

.login-tab-box {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  box-shadow: 2px 3.464px 8px 0px rgba(0, 0, 0, 0.047);
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
  .title {
    font-size: 20px;
    padding: 20px 30px;
  }
  .el-tabs__nav {
    margin-left: 25px;
  }
}

.login-container {
  .text-right {
    text-align: right;
  }
}

.login-header-tip {
  text-align: right;
  background: #37474f;
  padding: 4px 20px;
  color: #fff;
  font-size: 12px;
  img {
    vertical-align: middle;
    margin-right: 20px;
    width: 16px;
    margin-top: -2px;
  }
}

.login-logo-wrap {
  height: 60px;
  background: #fff;
  line-height: 60px;
  .login-title {
    color: #424242;
    font-size: 20px;
  }
  img {
    vertical-align: middle;
    margin: -5px 16px 0;
    margin-top: -5px;
  }
}

.login-tab-bg {
  img {
    width: 100%;
    min-height: 270px;
  }
}

.login-tab-content {
  padding: 24px;
}

.login-submit {
  width: 100%;
}

.login-tab-title {
  padding: 0 10px;
}

.login-tab-title-first {
  margin-left: 25px;
}
</style>
